import React from "react";

const Top = (props) => {
  return (
    <>
      <div className="mt-20">
        <div className="w-[100%]">
          <img
            className="mx-auto w-64 cursor-pointer duration-500 ease-in hover:relative hover:scale-105 hover:shadow-2xl lg:w-96"
            src={props.image}
            alt=""
          />
        </div>
        <div className="mt-4 lg:mt-12">
          <h1 className="text-center text-2xl font-bold">{props.title}</h1>
        </div>
        <button
          type="button"
          className="mx-auto ml-28 mt-5 inline-flex animate-pulse cursor-not-allowed items-center border border-gray-200 bg-white px-4 py-2 text-xl font-semibold shadow-md shadow-black hover:bg-gray-100 hover:text-blue-700 dark:hover:bg-blue-800 dark:hover:text-white lg:ml-32"
        >
          <svg
            className="mr-2 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M14.707 7.793a1 1 0 0 0-1.414 0L11 10.086V1.5a1 1 0 0 0-2 0v8.586L6.707 7.793a1 1 0 1 0-1.414 1.414l4 4a1 1 0 0 0 1.416 0l4-4a1 1 0 0 0-.002-1.414Z" />
            <path d="M18 12h-2.55l-2.975 2.975a3.5 3.5 0 0 1-4.95 0L4.55 12H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2Zm-3 5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" />
          </svg>
          {/* <!-- <a href="#"> Downloads</a> --> */}
          Download
        </button>
      </div>
    </>
  );
};

export default Top;
